/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbRespTradeSourcingBanner_itemSearch$ref = any;
export type SbRespTradeSourcingBanner_itemSearch = {
    readonly pageType: string | null;
    readonly topCategoryL1: VerticalType | null;
    readonly " $refType": SbRespTradeSourcingBanner_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespTradeSourcingBanner_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "pageType",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "topCategoryL1",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'b75c715f8c31aba28022b723e3c0ff06';
export default node;
